import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  fetchAllDropdownData,
  fetchClientData,
} from "../../Redux/Actions/dataActions"; // Adjust the path as needed
import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  Button,
  Typography,
  Grid,
  Autocomplete,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ListItemText,
  Chip,
  IconButton,
  Paper,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";
import { useSnackbar } from "../../Providers/SnackbarProvider";
import SessionNoteResponse from "../SessionNote/SessionNoteResponse";
import { useState } from "react";
import  { LoadingIndicator, GenerateLoadingIndicator } from "../../Components/Loader";
import { BASE_API_URL } from "../../constants";
import axiosInstance from "../../api/axiosInstance";
import { margin } from "@mui/system";
import { handleSubmit } from "../SessionNote/GenerateSessionNote";
import { xorDecrypt } from "../../encrypt";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 240,
    },
  },
};

const SessionNotesForm = () => {
  const dispatch = useDispatch();
  const sharedLink = BASE_API_URL;
  const { openSnackbar } = useSnackbar();
  const [responseDialogOpen, setResponseDialogOpen] = useState(false);
  const [responseData, setResponseData] = useState("");
  const enrollmentId = xorDecrypt(localStorage.getItem("latestEnrollmentId"));
  const [values, setValues] = useState({
    clientId: null,
    clientName: "",
    enrollmentId: enrollmentId,

    template: "TEMPLATE_H0032",

    otherplaceOfServiceCode: "",
    placeOfServiceCode: [],

    procedureCode: "H0032",

    sessionParticipants: [],
    otherSessionParticipants: "",

    progressTowardGoals: "",
    treatmentPlanFollowed: false,

    treatmentPlanSummary: "",
    modificationsAccommodations: "",
    otherInformation: [],

    nameOfPlanner: "",
    sessionPurpose: [],
    otherSessionPurpose: "",

    parentOrGurdianName: "",
  });

  const getAutocompleteStyles = () => ({
    marginTop: 2,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "#e9a132",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#e9a132",
      },
    },
    "& .MuiInputBase-input": {
      color: "white",
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "white",
    },
    "& .MuiAutocomplete-popupIndicator": {
      color: "white",
    },
    ".MuiChip-label": {
      color: "white",
    },
    "& .MuiChip-deleteIcon": {
      color: "white",
      "&:hover": {
        color: "#ff6666",
      },
    },
  });

  const fullState = useSelector((state) => state, shallowEqual);
  const dropdownData = fullState.data.dropdownData.data;
  const { loading, error } = fullState.data;
  const clients = useSelector((state) => state.data.clientData.data) || [];

  useEffect(() => {
    dispatch(fetchAllDropdownData());
    dispatch(fetchClientData()); // Fetch clients if needed
  }, [dispatch]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleCustomChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setValues({
      ...values,
      [name]: checked,
    });
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleDeleteChip = (name, chipToDelete) => () => {
    setValues((prevValues) => {
      const currentChips = prevValues[name];
      if (!Array.isArray(currentChips)) {
        console.error(
          `Expected an array for ${name}, but got ${typeof currentChips}`
        );
        return prevValues;
      }
      return {
        ...prevValues,
        [name]: currentChips.filter((chip) => chip !== chipToDelete),
      };
    });
  };
  if (loading) return <LoadingIndicator />;

  const colorfulTextStyle = {
    background: "linear-gradient(45deg, #ffa500, #ffffff, #ffa500)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
    marginBottom: "30px",
    marginTop: "20px",
  };

  return (
    <>
      <Box padding={2}>
        {/* <Typography variant="h4" gutterBottom sx={colorfulTextStyle}>
          Generate ABA Notes:
        </Typography> */}
        <form
          onSubmit={(event) =>
            handleSubmit(
              event,
              values,
              openSnackbar,
              setResponseData,
              setResponseDialogOpen
            )
          }
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={clients}
                name="clientId"
                getOptionLabel={(option) => option.clientName}
                value={
                  clients?.find((option) => option.id === values.clientId) ||
                  null
                }
                onChange={(event, newValue) => {
                  setValues({
                    ...values,
                    clientId: newValue ? newValue.id : null,
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Client Name"
                    name="clientId"
                    required
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 50, 
                      pattern: "[A-Za-z ]*",
                    }}
                    InputProps={{
                      ...params.InputProps,
                      sx: {
                        "& .MuiAutocomplete-input": {
                          color: "white", // Text color inside the Autocomplete input
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white", // Dropdown icon color
                        },
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "white", // Border color
                        },
                        "&:hover fieldset": {
                          borderColor: "#e9a132", // Hover state
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e9a132", // Focused state
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "white", // Keeps the label color consistent
                        "&.Mui-focused": {
                          color: "#e9a132", // Prevents the label color from changing on focus
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={dropdownData?.placeOfServiceCode || []}
                name="placeOfServiceCode"
                getOptionLabel={(option) => option}
                value={values.placeOfServiceCode || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "placeOfServiceCode",
                      value: newValue,
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Place of Service"
                    name="placeOfServiceCode"
                    required
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 50, 
                      pattern: "[A-Za-z ]*",
                    }}
                    InputProps={{
                      ...params.InputProps,
                      sx: {
                        "& .MuiAutocomplete-input": {
                          color: "white", // Text color inside the Autocomplete input
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white", // Dropdown icon color
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "white", // Clear icon color
                        },
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "white", // Border color
                        },
                        "&:hover fieldset": {
                          borderColor: "#e9a132", // Hover state
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e9a132", // Focused state
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "white", // Keeps the label color consistent
                        "&.Mui-focused": {
                          color: "#e9a132", // Prevents the label color from changing on focus
                        },
                      },
                      "& .MuiFormHelperText-root": {
                        color: "white", // Helper text color
                      },
                    }}
                  />
                )}
              />
            </Grid>

            {/* Repeat similar structure for other dropdowns with "Other" option */}

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <Autocomplete
                  multiple
                  options={dropdownData?.participants || []}
                  value={values.sessionParticipants}
                  onChange={(event, newValue) => {
                    handleChange({
                      target: { name: "sessionParticipants", value: newValue },
                    });
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        {...getTagProps({ index })}
                        onDelete={handleDeleteChip(
                          "sessionParticipants",
                          option
                        )}
                        deleteIcon={<CancelIcon sx={{ color: "white" }} />}
                        sx={{ margin: "4px", backgroundColor: "#e9a132" }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Session Participants"
                      placeholder="Select or type"
                      inputProps={{
                        ...params.inputProps,
                        maxLength: 50, 
                        pattern: "[A-Za-z ]*",
                      }}
                      InputLabelProps={{
                        style: {
                          color: "white",
                          "&.Mui-focused": {
                            color: "#e9a132",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e9a132",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e9a132",
                          },
                        },
                        "& .MuiInputBase-input": {
                          color: "white", // Ensures the text color inside the Autocomplete is white
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "white", // Ensures the clear icon is white
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white", // Ensures the dropdown icon is white
                        },
                        ".MuiChip-label": {
                          color: "white",
                        },
                        "& .MuiChip-deleteIcon": {
                          color: "white",
                          "&:hover": {
                            color: "#ff6666",
                          },
                        },
                      }}
                    />
                  )}
                />
                {values.sessionParticipants.includes("Other") && (
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Other Session Participants"
                    name="otherSessionParticipants"
                    value={values.otherSessionParticipants}
                    onChange={handleCustomChange}
                    inputProps={{
                      maxLength: 50, 
                      pattern: "[A-Za-z ]*",
                    }}
                    sx={{ marginTop: 2 }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <Autocomplete
                  multiple
                  options={dropdownData?.modificationsAccommodations || []}
                  value={values.modificationsAccommodations}
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "modificationsAccommodations",
                        value: newValue,
                      },
                    });
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        {...getTagProps({ index })}
                        onDelete={handleDeleteChip(
                          "progressTowardGoals",
                          option
                        )}
                        deleteIcon={<CancelIcon sx={{ color: "red" }} />}
                        sx={{ margin: "4px", backgroundColor: "#e9a132" }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Modifications Accommodations"
                      placeholder="Select or type"
                      inputProps={{
                        ...params.inputProps,
                        maxLength: 50, 
                        pattern: "[A-Za-z ]*",
                      }}
                      InputLabelProps={{
                        style: {
                          color: "white",
                          "&.Mui-focused": {
                            color: "#e9a132",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e9a132",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e9a132",
                          },
                        },
                        "& .MuiInputBase-input": {
                          color: "white",
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "white",
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white",
                        },
                        ".MuiChip-label": {
                          color: "white",
                        },
                        "& .MuiChip-deleteIcon": {
                          color: "white",
                          "&:hover": {
                            color: "#ff6666",
                          },
                        },
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Name Of Planner"
                  name="nameOfPlanner" // TextField for Name of Planner
                  value={values.nameOfPlanner}
                  onChange={handleChange}
                  inputProps={{
                    maxLength: 50, 
                    pattern: "[A-Za-z ]*",
                  }}
                  InputLabelProps={{
                    style: {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#e9a132",
                      },
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e9a132",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#e9a132",
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <Autocomplete
                  multiple
                  options={[...(dropdownData?.sessionPurpose || []), "Other"]}
                  value={values.sessionPurpose}
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "sessionPurpose",
                        value: newValue,
                      },
                    });
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        {...getTagProps({ index })}
                        onDelete={handleDeleteChip("sessionPurpose", option)}
                        deleteIcon={<CancelIcon sx={{ color: "white" }} />}
                        sx={{ margin: "4px", backgroundColor: "#e9a132" }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Session Purpose"
                      placeholder="Select or type"
                      inputProps={{
                        ...params.inputProps,
                        maxLength: 50, 
                        pattern: "[A-Za-z ]*",
                      }}
                      InputLabelProps={{
                        style: {
                          color: "white",
                          "&.Mui-focused": {
                            color: "#e9a132",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e9a132",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e9a132",
                          },
                        },
                        "& .MuiInputBase-input": {
                          color: "white", // Ensures the text color inside the Autocomplete is white
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "white", // Ensures the clear icon is white
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white", // Ensures the dropdown icon is white
                        },
                        ".MuiChip-label": {
                          color: "white",
                        },
                        "& .MuiChip-deleteIcon": {
                          color: "white",
                          "&:hover": {
                            color: "#ff6666",
                          },
                        },
                      }}
                    />
                  )}
                />
                {values.sessionPurpose.includes("Other") && (
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Other Session Purpose"
                    name="otherSessionPurpose"
                    value={values.otherSessionPurpose}
                    onChange={handleCustomChange}
                    sx={getAutocompleteStyles()}
                    inputProps={{
                      maxLength: 50, 
                      pattern: "[A-Za-z ]*",
                    }}
                    InputLabelProps={{
                      style: {
                        color: "white",
                        "&.Mui-focused": {
                          color: "#e9a132",
                        },
                      },
                    }}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Parent Or Gurdian Name"
                name="parentOrGurdianName"
                value={values.parentOrGurdianName}
                onChange={handleChange}
                inputProps={{
                  maxLength: 50, 
                  pattern: "[A-Za-z ]*",
                }}
                // Makes the TextField smaller
                InputProps={{
                  sx: {
                    "& .MuiAutocomplete-input": {
                      color: "white", // Text color inside the Autocomplete input
                    },
                  },
                }}
                InputLabelProps={{
                  style: {
                    fontSize: "1rem",
                    color: "white",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "white",
                      // Border color
                    },
                    "& .MuiOutlinedInput-input": {
                      color: "white",
                    },

                    "&:hover fieldset": {
                      borderColor: "#e9a132", // Hover state
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#e9a132", // Focused state
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: "white", // Keeps the label color consistent
                    "&.Mui-focused": {
                      color: "#e9a132", // Prevents the label color from changing on focus
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              >
                <Autocomplete
                  multiple
                  options={dropdownData?.progressTowardGoals || []}
                  value={values.progressTowardGoals}
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "progressTowardGoals",
                        value: newValue,
                      },
                    });
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        {...getTagProps({ index })}
                        onDelete={handleDeleteChip(
                          "progressTowardGoals",
                          option
                        )}
                        deleteIcon={<CancelIcon sx={{ color: "red" }} />}
                        sx={{ margin: "4px", backgroundColor: "#e9a132" }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Progress Toward Goals"
                      placeholder="Select or type"
                      inputProps={{
                        ...params.inputProps,
                        maxLength: 50, 
                        pattern: "[A-Za-z ]*",
                      }}
                      InputLabelProps={{
                        style: {
                          color: "white",
                          "&.Mui-focused": {
                            color: "#e9a132",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e9a132",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e9a132",
                          },
                        },
                        "& .MuiInputBase-input": {
                          color: "white",
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "white",
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white",
                        },
                        ".MuiChip-label": {
                          color: "white",
                        },
                        "& .MuiChip-deleteIcon": {
                          color: "white",
                          "&:hover": {
                            color: "#ff6666",
                          },
                        },
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="treatmentPlanFollowed"
                    checked={values.treatmentPlanFollowed}
                    onChange={handleCheckboxChange}
                    sx={{
                      color: "white", // Default color
                      "&.Mui-checked": {
                        color: "#e9a132", // Color when Checkbox is checked
                      },
                    }}
                  />
                }
                label="Treatment Plan Followed"
                sx={{
                  color: "white", // Change the color of the label here
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Treatment Plan Summary"
                name="treatmentPlanSummary"
                value={values.treatmentPlanSummary}
                onChange={handleChange}
                disabled={!values.treatmentPlanFollowed}
                inputProps={{
                  maxLength: 50, 
                  pattern: "[A-Za-z ]*",
                }}
                // Makes the TextField smaller
                InputProps={{
                  sx: {
                    "& .MuiAutocomplete-input": {
                      color: "white", // Text color inside the Autocomplete input
                    },
                  },
                }}
                InputLabelProps={{
                  style: {
                    fontSize: "1rem",
                    color: "white",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "white",
                      // Border color
                    },
                    "& .MuiOutlinedInput-input": {
                      color: "white",
                    },

                    "&:hover fieldset": {
                      borderColor: "#e9a132", // Hover state
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#e9a132", // Focused state
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: "white", // Keeps the label color consistent
                    "&.Mui-focused": {
                      color: "#e9a132", // Prevents the label color from changing on focus
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                {values.otherInformation.map((info, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "6px",
                    }}
                  >
                    <TextField
                      label="Other Information"
                      name={`otherInformation[${index}]`}
                      variant="outlined"
                      value={info}
                      inputProps={{
                        maxLength: 150, 
                        pattern: "[A-Za-z ]*",
                      }}
                      InputLabelProps={{
                        style: {
                          fontSize: "1rem", // Adjust font size as needed
                          color: "white", // Change label color
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white", // Border color
                          },
                          "& .MuiOutlinedInput-input": {
                            color: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e9a132", // Hover state
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e9a132", // Focused state
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "white", // Keeps the label color consistent
                          "&.Mui-focused": {
                            color: "#e9a132", // Prevents the label color from changing on focus
                          },
                        },
                      }}
                      fullWidth
                      onChange={(e) => {
                        const updatedInfo = [...values.otherInformation];
                        updatedInfo[index] = e.target.value;
                        setValues({
                          ...values,
                          otherInformation: updatedInfo,
                        });
                      }}
                    />
                    <IconButton
                      onClick={() => {
                        const updatedInfo = values.otherInformation.filter(
                          (_, i) => i !== index
                        );
                        setValues({
                          ...values,
                          otherInformation: updatedInfo,
                        });
                      }}
                    >
                      <CancelIcon sx={{ color: "red" }} />
                    </IconButton>
                  </Box>
                ))}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    sx={{
                      margin: "8px 0",
                      width: "100%", // Make the button fill the entire width
                      padding: "8px 12px", // Decrease padding for a smaller button height
                      backgroundColor: "#e9a132", // Change button background color
                      color: "white", // Change text color for better contrast
                      "&:hover": {
                        backgroundColor: "#c7912c", // Slightly darker shade on hover
                      },
                    }}
                    onClick={() =>
                      setValues({
                        ...values,
                        otherInformation: [...values.otherInformation, ""],
                      })
                    }
                  >
                    + More Information
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      margin: "8px 0",
                      width: "100%", // Make the button fill the entire width
                      padding: "8px 12px", // Decrease padding for a smaller button height
                      backgroundColor: "#e9a132", // Change button background color
                      color: "white", // Change text color for better contrast
                      "&:hover": {
                        backgroundColor: "#c7912c", // Slightly darker shade on hover
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </FormControl>
            </Grid>

            {/* <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: "#e9a132", // Change button background color
                  color: "white", // Change text color for better contrast
                  "&:hover": {
                    backgroundColor: "#c7912c", // Slightly darker shade on hover
                  },
                }}
              >
                Submit
              </Button>
            </Grid> */}
          </Grid>
        </form>
      </Box>

      <SessionNoteResponse
        open={responseDialogOpen}
        onClose={() => setResponseDialogOpen(false)}
        handleSubmit={handleSubmit}
        clients={clients}
        InitialValues={values}
        procedureCode={values.procedureCode}
        placeOfServiceCode={values.placeOfServiceCode}
        sessionParticipants={values.sessionParticipants}
        responseData={responseData}
      />
    </>
  );
};

export default SessionNotesForm;
